let accordion = document.querySelectorAll('.accordion');
let showAnswears = document.querySelector('.section-faq--showAnswears');
let answearsWrapper = document.querySelector('.section-faq--content');

accordion.forEach(element => {
  let accordionTitle = element.querySelector('.accordion__summary');

  accordionTitle.addEventListener('click', () => {
    let content = element.querySelector('.accordion__content');
    if (element.classList.contains('active')) {
      element.classList.remove('active');
      content.style.maxHeight = null;
      return;
    }
    element.classList.add('active');
    content.style.maxHeight = content.scrollHeight + "px";
  });
});

showAnswears.addEventListener('click', () => {
  if (answearsWrapper.classList.contains('section-faq--contentHidden')) {
    answearsWrapper.classList.remove('section-faq--contentHidden');
    answearsWrapper.classList.add('section-faq--contentActive');

    showAnswears.classList.add('active');
  } else {
    answearsWrapper.classList.add('section-faq--contentHidden');
    answearsWrapper.classList.remove('section-faq--contentActive');

    showAnswears.classList.remove('active');
  }
})

const buttonDownFAQ = document.querySelector(".section-faq--button");

  if (buttonDownFAQ) {
    buttonDownFAQ.addEventListener("click", buttonScroll);
  }

  function buttonScroll(event) {
    let button = event.target.closest("button");
    let scrollToData = button.getAttribute("data-scroll-to");
    if (scrollToData) {
      event.preventDefault();
      let scrollToElement = document.querySelector(`${scrollToData}`);
      
      window.scrollTo({
        top: scrollToElement.offsetTop - 57,
        behavior: "smooth",
      });
    } else {
    
    }
  }